// src/DID.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import GlobalStyle from '../GlobalStyles';
import Footer from '../components/Footer';
import BannerWithCard from '../components/BannerWithCard';
import DIDSection2 from '../components/DIDSection2';
import DIDSection3 from '../components/DIDSection3';
import DIDSection3_1 from '../components/DIDSection3_1';
import DIDSection4 from '../components/DIDSection4';
import DIDSection5 from '../components/DIDSection5';


const Container = styled.div`
  max-width: 100%;
  margin:0px;
  padding: 0px;
  background-color:#000000;
`;


function DID() {



  return (

    <Container>
   
        <Navbar />
        <BannerWithCard /> 
        <DIDSection2 />
        <DIDSection3 />
        <DIDSection3_1 />
        <DIDSection4 />
        <DIDSection5 />
        


        <Footer /> 

    </Container>

  );
}

export default DID;